import './Navigation.svelte.css';
/* src/components/Navigation.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { expressionStore } from "./stores.js";
import LocalizedExpression from "./LocalizedExpression.svelte.js";
import "./Chart.svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (25:0) {#if workspaceItems.length > 0}
function create_if_block_3(ctx) {
	let input;
	let mounted;
	let dispose;

	return {
		c() {
			input = element("input");
			attr(input, "type", "text");
			attr(input, "placeholder", "Buscar");
			attr(input, "class", "svelte-1yvchiw");
		},
		m(target, anchor) {
			insert(target, input, anchor);
			set_input_value(input, /*searchInput*/ ctx[0]);

			if (!mounted) {
				dispose = listen(input, "input", /*input_input_handler*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*searchInput*/ 1 && input.value !== /*searchInput*/ ctx[0]) {
				set_input_value(input, /*searchInput*/ ctx[0]);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			mounted = false;
			dispose();
		}
	};
}

// (30:2) {#if workspaceItems.length === 0}
function create_if_block_2(ctx) {
	let t;

	return {
		c() {
			t = text("Os símbolos que você definir serão listados aqui.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (42:6) {#if item.evaluation !== undefined}
function create_if_block_1(ctx) {
	let t;
	let localizedexpression;
	let current;

	localizedexpression = new LocalizedExpression({
			props: {
				stringified: /*item*/ ctx[5].evaluation.toString()
			}
		});

	return {
		c() {
			t = text("=\n        ");
			create_component(localizedexpression.$$.fragment);
		},
		m(target, anchor) {
			insert(target, t, anchor);
			mount_component(localizedexpression, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localizedexpression_changes = {};
			if (dirty & /*filtered*/ 4) localizedexpression_changes.stringified = /*item*/ ctx[5].evaluation.toString();
			localizedexpression.$set(localizedexpression_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localizedexpression.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localizedexpression.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t);
			destroy_component(localizedexpression, detaching);
		}
	};
}

// (36:2) {#each filtered as item}
function create_each_block(ctx) {
	let li;
	let a;
	let t0_value = /*item*/ ctx[5].expression.identifier + "";
	let t0;
	let a_href_value;
	let t1;
	let t2;
	let current;
	let if_block = /*item*/ ctx[5].evaluation !== undefined && create_if_block_1(ctx);

	return {
		c() {
			li = element("li");
			a = element("a");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			attr(a, "href", a_href_value = "#" + /*item*/ ctx[5].expression.identifier);
			attr(li, "class", "svelte-1yvchiw");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, a);
			append(a, t0);
			append(li, t1);
			if (if_block) if_block.m(li, null);
			append(li, t2);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*filtered*/ 4) && t0_value !== (t0_value = /*item*/ ctx[5].expression.identifier + "")) set_data(t0, t0_value);

			if (!current || dirty & /*filtered*/ 4 && a_href_value !== (a_href_value = "#" + /*item*/ ctx[5].expression.identifier)) {
				attr(a, "href", a_href_value);
			}

			if (/*item*/ ctx[5].evaluation !== undefined) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*filtered*/ 4) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(li, t2);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (if_block) if_block.d();
		}
	};
}

// (50:0) {#if filtered.length === 0 && workspaceItems.length > 0}
function create_if_block(ctx) {
	let t;

	return {
		c() {
			t = text("Nenhum resultado para a busca.");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let h2;
	let t1;
	let t2;
	let p;
	let t3;
	let ul;
	let t4;
	let if_block2_anchor;
	let current;
	let if_block0 = /*workspaceItems*/ ctx[1].length > 0 && create_if_block_3(ctx);
	let if_block1 = /*workspaceItems*/ ctx[1].length === 0 && create_if_block_2(ctx);
	let each_value = /*filtered*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block2 = /*filtered*/ ctx[2].length === 0 && /*workspaceItems*/ ctx[1].length > 0 && create_if_block(ctx);

	return {
		c() {
			h2 = element("h2");
			h2.textContent = "Seus símbolos";
			t1 = space();
			if (if_block0) if_block0.c();
			t2 = space();
			p = element("p");
			if (if_block1) if_block1.c();
			t3 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t4 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			attr(h2, "class", "svelte-1yvchiw");
			attr(ul, "class", "svelte-1yvchiw");
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			insert(target, t1, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t2, anchor);
			insert(target, p, anchor);
			if (if_block1) if_block1.m(p, null);
			insert(target, t3, anchor);
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(ul, null);
				}
			}

			insert(target, t4, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*workspaceItems*/ ctx[1].length > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(t2.parentNode, t2);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*workspaceItems*/ ctx[1].length === 0) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					if_block1.m(p, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*filtered, undefined*/ 4) {
				each_value = /*filtered*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (/*filtered*/ ctx[2].length === 0 && /*workspaceItems*/ ctx[1].length > 0) {
				if (if_block2) {
					
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(h2);
			if (detaching) detach(t1);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t2);
			if (detaching) detach(p);
			if (if_block1) if_block1.d();
			if (detaching) detach(t3);
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t4);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

function filterWorkspaceItems(items, search) {
	if (search.trim().length === 0) {
		return items;
	}

	return items.filter(({ expression: { identifier } }) => identifier.includes(search));
}

function sortItems(items) {
	items.sort((left, right) => left.position - right.position);
	return items;
}

function instance($$self, $$props, $$invalidate) {
	let $expressionStore;
	component_subscribe($$self, expressionStore, $$value => $$invalidate(3, $expressionStore = $$value));
	let searchInput = "";
	let workspaceItems;
	let filtered;

	function input_input_handler() {
		searchInput = this.value;
		$$invalidate(0, searchInput);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$expressionStore, workspaceItems, searchInput*/ 11) {
			$: {
				$$invalidate(1, workspaceItems = [...$expressionStore.values()]);
				$$invalidate(2, filtered = sortItems(filterWorkspaceItems(workspaceItems, searchInput)));
			}
		}
	};

	return [searchInput, workspaceItems, filtered, $expressionStore, input_input_handler];
}

class Navigation extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Navigation;